import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "@/config/firebase";

export interface LectureDetailBookingItem {
  studiomateMemberId: number;
  memberName: string;
  status: string;
}

export interface GetStudiomateLectureDetailResponse {
  bookings: LectureDetailBookingItem[];
  error?: {
    code: string;
    message: string;
  };
}

export async function fetchStudiomateLectureDetail(
  lectureId: number,
  centerId?: number,
): Promise<GetStudiomateLectureDetailResponse> {
  const fn = httpsCallable<
    { lectureId: number; centerId?: number },
    GetStudiomateLectureDetailResponse
  >(getFirebaseFunctions(), "getStudiomateLectureDetail");

  const result = await fn({ lectureId, ...(centerId != null ? { centerId } : {}) });
  return result.data;
}
